export const text = {
    senha_sucesso: "Nueva contrasenã se ha creado correctamente",
    senha_diferentes: "Las contraseñas son diferentes",
    dados_invalidos: "La información ingresada es incorrecta, vuelva a intentar o póngase en contacto con el CAN",
    erroEnvio : "No se pudo enviar el código",
    erroEmailTelefone : "La persona no tiene email y número de telefono registrado",
	erroEmail : "La persona no tiene email registrado",
	erroTelefone : "La persona no tiene número de telefono registrado",
    envio_email_senha_sucesso: "Dentro de unos momentos usted recibirá un e-mail con los datos de la nueva contraseña",
    envio_email_link_sucesso: "Dentro de unos momentos usted recibirá un e-mail con el link para ingresar la nueva contraseña",
    erroApiSMS: "No fue posible enviar el código verificador por SMS. Motivo: "
  };
  